import { Fragment } from 'react';
import PropTypes from 'prop-types';
import { createFragmentContainer, graphql } from 'react-relay/legacy.js';

import HeadingLevel from 'dibs-controlled-heading/exports/HeadingLevel.tsx';

import dibsCss from 'dibs-css';
import classnames from 'classnames';
import styles from './SharedBottomModuleContent.scss';

const SharedBottomModuleContentComponent = ({ bottomModule }) => {
    return (
        <>
            {bottomModule.map(item =>
                item.title && item.description ? (
                    <Fragment key={item.title}>
                        <HeadingLevel>
                            {Heading => (
                                <Heading
                                    className={classnames(
                                        dibsCss.sassyFontBodySmallHeavy,
                                        dibsCss.mtSmall,
                                        dibsCss.m0
                                    )}
                                >
                                    {item.title}
                                </Heading>
                            )}
                        </HeadingLevel>
                        <div
                            className={classnames(
                                styles.description,
                                dibsCss.sassyFontBodySizeSmall
                            )}
                            dangerouslySetInnerHTML={{ __html: item.description }}
                        />
                    </Fragment>
                ) : null
            )}
        </>
    );
};

SharedBottomModuleContentComponent.propTypes = {
    bottomModule: PropTypes.any,
};

export const SharedBottomModuleContent = createFragmentContainer(
    SharedBottomModuleContentComponent,
    {
        bottomModule: graphql`
            fragment SharedBottomModuleContent_bottomModule on BottomModule @relay(plural: true) {
                title
                description
            }
        `,
    }
);
